module.exports = __webpack_public_path__ + "img/story037@2x.9071346a.webp";